import { createContext, useContext } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var AppearanceContext = /*#__PURE__*/createContext(null);
export var AppearanceProvider = function AppearanceProvider(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children;
  return _jsx(AppearanceContext.Provider, {
    value: appearance !== null && appearance !== void 0 ? appearance : null,
    children: children
  });
};
export var useAppearance = function useAppearance(appearance) {
  var _ref3;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultAppearance = _ref2.defaultAppearance;

  var scopedAppearance = useContext(AppearanceContext);
  var finalAppearance = (_ref3 = appearance !== null && appearance !== void 0 ? appearance : scopedAppearance) !== null && _ref3 !== void 0 ? _ref3 : defaultAppearance;

  if (finalAppearance === null || finalAppearance === undefined) {
    if (true) throw new Error();else throw new Error("Appearance isn't available. One of two must be valid: `useAppearance` hook is used within AppearanceContext or appearance is provided via arguments");
  }

  return finalAppearance;
};